import { Layout } from '@ui-kitten/components';
import { Modal, SafeAreaView, ScrollView, StyleSheet, View } from 'react-native';
import React, { useCallback, useState } from 'react';
import { YourHealthRecords } from '../../components/profileMeHealthRecords';
import { RootTabScreenProps, UIHelper as uh } from '../../core';

//import DisableTenantFeature from 'src/components/shared/DisableTenantFeature';
import RefreshControl from 'src/components/shared/RefreshControl';
import { mainStyles } from './_mainStyles';
import HealthRecordDetailModal from 'src/components/profileMeHealthRecords/modal/HealthRecordDetailModal';

const HealthRecordsScreen = ({ route, navigation }: RootTabScreenProps<any>) => {
  // const tenantFeatures: TenantFeature[] = useGetTenantFeatures();
  const [modalVisible, setModalVisible] = React.useState(false);
  const [type, setType] = React.useState<string>('');
  const [item, setItem] = React.useState<any>();

  const styleContainer = StyleSheet.create({
    screenContainer: { flex: 1 },
    safeAreaView: { flex: 1 },
    container: {
      flex: 1
    },
    learnMore: { marginTop: uh.h2DP(40) },
    divider: { marginTop: uh.h2DP(16), marginBottom: uh.h2DP(16) },
    chatQuote: { marginTop: uh.h2DP(16) },
    btnUpload: { marginTop: uh.h2DP(16) },
    btnInfo: { marginTop: uh.h2DP(18) },
    backdrop: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  });

  const [refreshing, setRefreshing] = useState<boolean>(false);
  // const [isHealthRecordsScreenEnable, setIsHealthRecordsScreenEnable] = useState(true);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
  }, []);

  // useEffect(() => {
  //   const isEnableHealthRecords =
  //     tenantFeatures.find((item: TenantFeature) => item.key == 'ConsolidateHealthFeature') != undefined;
  //   setIsHealthRecordsScreenEnable(true);
  // }, [tenantFeatures]);

  const renderModalContentElement = () => {
    return <HealthRecordDetailModal data={item} type={type} btnBackHandler={() => setModalVisible(false)} />;
  };

  const finishRefreshing = React.useCallback(() => {
    setRefreshing(false);
  }, []);

  const handleDetailClick = React.useCallback(
    (type: string, item: any) => {
      setItem(item);
      setType(type);
      setModalVisible(true);
    },
    [setItem, setType, setModalVisible]
  );

  return (
    <Layout level="2" style={[styleContainer.screenContainer]}>
      <ScrollView
        contentContainerStyle={[{ flexGrow: 1 }, mainStyles.mainScreenContainer]}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
        {/* {isHealthRecordsScreenEnable ? ( */}
        <SafeAreaView style={styleContainer.screenContainer}>
          <YourHealthRecords
            btnDetailHealthRecordClick={handleDetailClick}
            refreshing={refreshing}
            finishRefreshing={finishRefreshing}
          />
        </SafeAreaView>
        {/* ) : (
          <DisableTenantFeature />
        )} */}
        <Modal visible={modalVisible} transparent animationType="fade" onRequestClose={() => setModalVisible(false)}>
          <View style={[StyleSheet.absoluteFill, styleContainer.backdrop, { justifyContent: 'center' }]}>
            {renderModalContentElement()}
          </View>
        </Modal>
      </ScrollView>
    </Layout>
  );
};

export default HealthRecordsScreen;
